var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7596 29.959C65.8613 18.8795 57.1205 10.1388 46.041 7.24043C45.6172 3.17795 42.1731 0 38.0001 0C33.8271 0 30.3828 3.17795 29.9592 7.24043C18.8797 10.1388 10.139 18.8797 7.24061 29.959C3.17795 30.3828 0 33.8269 0 38.0001C0 42.1733 3.17795 45.6174 7.24061 46.041C10.1388 57.1205 18.8797 65.8612 29.9592 68.7596C30.383 72.8222 33.8271 76.0002 38.0001 76.0002C42.1731 76.0002 45.6174 72.8224 46.041 68.7596C57.1205 65.8613 65.8612 57.1205 68.7596 46.041C72.8222 45.6172 76.0002 42.1731 76.0002 38.0001C76.0002 33.8271 72.8222 30.3828 68.7596 29.959ZM65.0072 45.5424C62.3765 54.9505 54.9505 62.3763 45.5424 65.0072C44.3721 61.9818 41.4336 59.8294 38.0001 59.8294C34.5666 59.8294 31.6281 61.9818 30.4578 65.0072C21.0499 62.3765 13.6239 54.9507 10.993 45.5424C14.0184 44.3721 16.1708 41.4336 16.1708 38.0001C16.1708 34.5666 14.0184 31.6281 10.993 30.4578C13.6237 21.0497 21.0495 13.6239 30.4578 10.993C31.6281 14.0184 34.5664 16.1708 38.0001 16.1708C41.4337 16.1708 44.3721 14.0184 45.5424 10.993C54.9505 13.6237 62.3763 21.0495 65.0072 30.4578C61.9818 31.6281 59.8294 34.5666 59.8294 38.0001C59.8294 41.4334 61.9818 44.3719 65.0072 45.5424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6172 51.0072C28.6172 51.685 29.1678 52.2347 29.8456 52.2347H46.1488C46.8264 52.2347 47.3772 51.685 47.3772 51.0072V48.5728H28.6172V51.0072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1492 35.6766H45.7076V31.4751C45.7076 27.2239 42.249 23.7651 37.9974 23.7651C33.7458 23.7651 30.2872 27.2239 30.2872 31.4751V35.6766H29.8456C29.1678 35.6766 28.6172 36.2267 28.6172 36.9045V46.3214H47.3772V36.9045C47.3776 36.2267 46.8268 35.6766 46.1492 35.6766ZM42.706 35.6766H33.289V31.4751C33.289 28.8789 35.4012 26.7667 37.9976 26.7667C40.594 26.7667 42.7061 28.8789 42.7061 31.4751V35.6766H42.706Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.319c041d34fd067cb5001f8f43c14327.svg";
export { ForwardRef as ReactComponent };